exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field[data-v-0a2f53d1] {\n  display: flex;\n}\n.field label[data-v-0a2f53d1] {\n  width: auto;\n  display: block;\n  margin-right: 10px;\n}\n.radio-holder label[data-v-0a2f53d1] {\n  margin-top: 0;\n}\ninput[type=tel][data-v-0a2f53d1] {\n  border: none;\n  border-bottom: 1px solid #ddd;\n  box-shadow: none;\n  font-size: 13px;\n  flex-grow: 1;\n  width: 100%;\n}\ninput[type=tel][data-v-0a2f53d1]:focus {\n  outline: none;\n  box-shadow: none;\n  border: none;\n  border-bottom: 1px solid #ddd;\n}", ""]);

// exports
